import { type ComponentChildren, createContext } from "preact";
import { useContext, useState } from "preact/hooks";

type HeaderContextType = {
  actions: ComponentChildren;
  setActions: (actions: ComponentChildren) => void;
};

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

/** Lets a page put its own buttons into the mobile header (see `useHeaderActions`). */
export const HeaderContextProvider = ({ children }: { children: ComponentChildren }) => {
  const [actions, setActions] = useState<ComponentChildren>(null);
  return <HeaderContext.Provider value={{ actions, setActions }}>{children}</HeaderContext.Provider>;
};

export const useHeaderContext = (): HeaderContextType => {
  const context = useContext(HeaderContext);
  if (context === undefined) {
    throw new Error("useHeaderContext must be used within a HeaderContextProvider");
  }
  return context;
};
